import { ApolloProvider } from "@apollo/client";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import { ConfigProvider } from "antd";
import locale from "antd/locale/fr_FR";
import "dayjs/locale/fr";
import EmailComposer from "shared/components/EmailComposer";
import { EmailComposerProvider } from "shared/components/EmailComposer/context";
import client from "shared/graphql";
import { GlobalSubscriptionContext } from "shared/services/subscriptions";
import { StoreProvider } from "shared/store";
import { PreviousDisplayProvider } from "shared/store/previousDisplay";
import { loadAuthProvider } from "utils/helpers/authProvider";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./shared/locales/i18n";
import "./shared/style/style.scss";
// @ts-ignore

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <ApolloProvider client={client}>
      <HashRouter>
        <GlobalSubscriptionContext client={client}>
          <StoreProvider>
            <PreviousDisplayProvider>
              <EmailComposerProvider>
                <ConfigProvider locale={locale}>
                  <App />
                  <EmailComposer />
                </ConfigProvider>
              </EmailComposerProvider>
            </PreviousDisplayProvider>
          </StoreProvider>
        </GlobalSubscriptionContext>
      </HashRouter>
    </ApolloProvider>,
  );
};

// Resolve the active auth provider before first render so synchronous consumers
// (refresh link, logout) and the Signin screen have it available.
loadAuthProvider().finally(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
